import { SupplierActivationContent } from './SupplierActivationContent'
import { SupplierActivationFilterCriteria } from './SupplierActivationFilterCriteria'

export const SupplierActivation = () => (
  <SupplierActivationFilterCriteria>
    <SupplierActivationContent />
  </SupplierActivationFilterCriteria>
)
